import { Badge } from "antd";
import type { BadgeProps } from "antd";

export type UIBadgeProps = BadgeProps;

export const UIBadge = (props: UIBadgeProps) => <Badge {...props} />;
